export default __webpack_public_path__ + "static/media/portfolio-cregar-1.dfec2713.jpg";